<li
	class="group/list-item w-full py-4 flex justify-between items-center gap-2 h-[5.5rem]"
>
	<span
		class="my-auto flex items-center gap-2 min-w-8 w-fit group-has-[input:disabled]/list-item:opacity-50 transition-opacity duration-300"
	>
		<ui-avatar [initials]="recipientInitials()" [variant]="avatarVariant()" />
		<p class="w-full truncate">{{ recipientName() }}</p>
	</span>
	<div class="flex justify-end gap-4 items-center flex-[0_1_56%]">
		<div class="my-auto w-full">
			<app-input
				#emailInput
				[ngModel]="recipientValues().email"
				(ngModelChange)="onEmailChange($event)"
				[ariaLabel]="recipientName() + '\'s email input'"
				class="min-w-48 transition-all duration-300"
				type="email"
				[required]="recipientValues().isParticipating"
				email
				[disabled]="!recipientValues().isParticipating"
			/>
			@if (emailInput.ngControl.invalid && submitted_()) {
				<p class="text-sm text-red-600">Please enter a valid email address.</p>
			}
		</div>

		<ui-toggle
			[ngModel]="recipientValues().isParticipating"
			(ngModelChange)="updateIsRecipientParticipating()"
			[type]="TOGGLE_TYPES.ICON_DEFAULT"
		/>
	</div>
</li>
